import {OrderService, MovieService, RegionService} from 'hasta-la-vista-middleware-api/service'
export default {
    data() {
        return {
            loading: true,
            selected_concession: null,
            cinema_type: "standalone",
            cinema_id: "", //stand alone purchase Cinema ID
            donation_name: "Donations",
            cancelAlert: false,
            items: [],
            order: null
        }
    },

    methods: {
        confirmAmount() {
            this.loading = true
            Promise.resolve(OrderService.newConcessionOrder(this.selected_concession, this.cinema_id)).then((order) => {
                // console.log("Order", order)
                if(order) {
                    this.order = order
                    this.$router.push('/donate/2');
                } else {

                }
            },
            (error) => {
                this.loading = false
                Promise.reject(error)
            });
        },

        getConcessionItems(concessionItems) {
            var items = []
            for(var k = 0; k < concessionItems.length; k++) {
                if(concessionItems[k].Description != "DONATION R2.50") {
                    var item = concessionItems[k]
                    item.Price = "R " + (concessionItems[k].PriceInCents / 100)
                    item.Quantity = 1
                    items[k] = item
                }
            }

            return items
        }
    },

    created() {
        this.loading = true
        Promise.all([OrderService.getConsessionsByCinemaId(this.cinema_type), OrderService.cancelConcessionOrder(this.cinema_id), OrderService.getStandAloneCinemaId(this.cinema_type)]).then(
            ([concessions, cancel_order, cinema_id]) => {

                this.cinema_id = cinema_id;

                for(var i = 0; i < concessions.length; i++) {
                    if(concessions[i].Name == this.donation_name) {
                        this.items = this.getConcessionItems(concessions[i].ConcessionItems);
                    }
                }
                this.loading = false
            }, 
            (error) => {
                Promise.reject(error)
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/donate/choose-amount/choose-amount.js